import React, { Component } from 'react';
import CollectionBrowser from "./../../components/collectionBrowser";
import LookBookQuoteContainer from "./../../components/lookBookQuoteContainer";
import CollectionHero from "./../../components/collectionHero";
import LookBookCenteredImage from "./../../components/lookBookCenteredImage";
import LookBookFullWidthImage from "./../../components/lookBookFullWidthImage";
import LookBookOnePhotoAndColor from "./../../components/lookBookOnePhotoAndColor";
import LookBookSideBySideImages from "./../../components/lookBookSideBySideImages";
import StoryFooter from "./../../components/storyFooter";
import ScrollFadeIn from "./../../components/scrollFadeIn";
import BannerFadeIn from "./../../components/bannerFadeIn";
import BackButton from './../../alpineComponents/backButton';
import Footer from './../../components/footer';
import {Helmet} from "react-helmet";

//yearlyauditPdf

export default class YearlyAudit extends Component {

  render() {
    return (
      <div>
        <Helmet>
          <title>{'Free PDF - How to Find Time for Yourself Kat Medina'}</title>
          <meta name="description" content="When there aren't enough hours in your day" />
        </Helmet>
        <BannerFadeIn>
          <div className="background-image-fill" style={{backgroundImage:`url(/images/blog-joy.jpg)`}}>
            <div className="brain-fucks-hero extra-large-padding centered-text" style={{backgroundColor:'rgba(0,0,0,.5)'}}>
              <h2 className="white full-width centered-text">{'How to find time for yourself'}</h2>
              <p className="white">{'Get a free, printable PDF with a list of real-life ways to squeeze in you-time.'}</p>
            </div>
          </div>
        </BannerFadeIn>
        <ScrollFadeIn>
          <div className="small-max-width-container lip">
            <div className="medium-padding primary-background centered-text mailchimp-form-container">
              <div className="small-max-width-container">
                
              </div>
            </div>
          </div>
        </ScrollFadeIn>
        <Footer />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/findingTime/index.js